import React from 'react'
import { Pressable, Text } from 'react-native'

import { languageSwitcher } from '@ui-kit/components/LanguageSwitcher/styles'

import type { NativeProps } from './types'

const LanguageSwitcher = (props: NativeProps) => {
  const { container, text, disabledLanguage, separator } = languageSwitcher()
  return (
    <Pressable className={container()} id={props.id} onPress={props.onPress}>
      {props.availableLanguages.map((language, key) => {
        return (
          <Text className={text()} key={language}>
            {props.lang === language ? (
              language
            ) : (
              <Text className={disabledLanguage()}>{language}</Text>
            )}

            {
              // render separator
              key < props.availableLanguages.length - 1 ? (
                <Text className={separator()}>/</Text>
              ) : null
            }
          </Text>
        )
      })}
    </Pressable>
  )
}

export default LanguageSwitcher
